module.exports = __webpack_public_path__ + "static/media/Pet Adoption App.55403807.png";